module.exports = __webpack_public_path__ + "static/media/desktop-picture-retina-medium.549520ae.jpeg";